import { render, staticRenderFns } from "./my-ngo-support-group-list.html?vue&type=template&id=4f2ff134&scoped=true&external"
import script from "./my-ngo-support-group-list.js?vue&type=script&lang=js&external"
export * from "./my-ngo-support-group-list.js?vue&type=script&lang=js&external"
import style0 from "./my-ngo-support-group-list.scss?vue&type=style&index=0&id=4f2ff134&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ff134",
  null
  
)

export default component.exports